export const BASE_FARE = "Base fare";
export const TAXES_AND_FEES = "Taxes & fees";
export const SEAT_SELECTION = "Seat selection";
export const DISRUPTION_PROTECTION = "Flight disruption assistance";
export const CANCEL_FOR_ANY_REASON = "Cancel for any reason";
export const CHANGE_FOR_ANY_REASON = "Change your flight for any reason";
export const TRIP_TOTAL = "Total";
